import { Pipe, PipeTransform } from '@angular/core';
import { ContactMatrixLevel, ContactMatrixDepartment } from '../../../dto';

@Pipe({
    name: 'contactTotal',
    standalone: false
})
export class ContactTotalPipe implements PipeTransform {
    transform(matrixKey: string, matrixTotals: ContactMatrixLevel | ContactMatrixDepartment ): number {
        if (matrixKey in matrixTotals) {
            return matrixTotals[matrixKey];
        }
        return 0;
    }
}
